export const IMG_URL = 'https://api.themoviedb.org/3';
